import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import DefaultMoto from '../../../images/default-moto.png';

const AdsThumbnail = ({ photo, model, }) => {
  const classes = useStyles();
  return (
    <td>
      <div className={classes.imageWrapper}>
        <img src={photo || DefaultMoto} alt={model} />
      </div>
    </td>
  );
};

const useStyles = createUseStyles({
  imageWrapper: {
    width: '140px',
    '& img': {
      width: '100%',
      height: 'auto',
      marginBottom: '-6px',
    },
  },
  '@media screen and (min-width: 992px)': {
    imageWrapper: {
      width: '200px',
    },
  },
});

AdsThumbnail.propTypes = {
  photo: PropTypes.string,
  model: PropTypes.string,
};

AdsThumbnail.defaultProps = {
  photo: null,
  model: null,
};

export default AdsThumbnail;
